import fetch from "auth/FetchInterceptor";

export const InventoryService = {};

InventoryService.get = async ({ page, pageSize, sort, searchText }) => {
  let apiUrl =
    "/v1/outlet/inventory?includeExpiry=true&page=" +
    page +
    "&per_page=" +
    pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Dname";
  else if (sort === "descend") apiUrl += "&order_by=%2Bname";
  if (searchText) apiUrl += "&name=" + searchText;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

InventoryService.getReport = async ({
  searchOutlet,
  searchProduct,
  endDate,
}) => {
  let apiUrl = "/v1/outlet/inventory-report?order_by=%2Dname";
  if (searchOutlet) apiUrl += "&outlet=" + searchOutlet;
  if (searchProduct) apiUrl += "&product=" + searchProduct;
  if (endDate) apiUrl += "&date=" + endDate;
  return fetch({
    url: apiUrl,
    method: "get",
    timeout: 120000, // 2 min timeout for inventory report (large dataset)
  });
};

InventoryService.getById = async (id) => {
  const apiUrl = `/v1/outlet/${id}/inventory?includeExpiry=true`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

InventoryService.updateInventory = async (data) => {
  const apiUrl = `/v1/outlet/${data.id}/inventory`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

export default InventoryService;
